import { StoryblokJobPlugin } from './StoryblokJobPlugin'

export default StoryblokJobPlugin
